"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _utils = require("../_util/utils");
var _jsxRuntime = require("react/jsx-runtime");
const SkeletonButton = props => {
  const {
    loading = true,
    active = true,
    size = 'm',
    width = 128,
    children,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style,
    ...restProps
  } = props;
  const baseClassName = "".concat(prefixClass, "-skeletonButton");
  const attrs = (0, _utils.pickDomAttrs)(restProps);
  if (children === false || children === null || children === undefined) {
    return null;
  }
  if (loading) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      ...attrs.data,
      className: (0, _classnames.default)(className, baseClassName, {
        active
      }, size),
      style: {
        width,
        ...style
      }
    });
  }
  return children;
};
var _default = exports.default = SkeletonButton;